export const translations = {
  en: {
    header: {
      home: 'Home',
      about: 'About',
      team: 'Our Team',
      services: 'Services',
      gemstones: 'Gemstones',
      testimonials: 'Testimonials',
      blog: 'Blog',
      contact: 'Contact',
      bookConsultation: 'Book Consultation',
      vedicAstrologer: 'Vedic Astrologer'
    },
    home: {
      hero: {
        title: 'Discover Your Destiny Through',
        subtitle: 'Ancient Vedic Wisdom',
        description: 'Experience authentic Vedic astrology guidance with Acharyaa Indira Pandey. Over 20 years of expertise in birth chart analysis, career guidance, and personalized remedies.',
        cta: 'Book Your Consultation',
        learnMore: 'Learn More',
        astrologerName: 'Acharyaa Indira Pandey'
      },
      stats: {
        experience: 'Years Experience',
        clients: 'Happy Clients',
        satisfaction: 'Satisfaction Rate',
        consultations: 'Consultations/Week'
      },
      whyChoose: {
        title: 'Why Choose Acharyaa Indira Pandey?',
        subtitle: 'Experience the difference of personalized, accurate, and compassionate astrological guidance',
        card1Title: 'Expert Guidance',
        card1Desc: '20+ years of dedicated practice in Vedic astrology with proven accuracy',
        card2Title: 'Trusted by Many',
        card2Desc: '5000+ satisfied clients including professionals and celebrities',
        card3Title: 'Personalized Approach',
        card3Desc: 'Every consultation is tailored to your unique birth chart and needs',
        card4Title: 'Complete Confidentiality',
        card4Desc: 'Your privacy is paramount. All consultations remain strictly confidential'
      },
      services: {
        title: 'Our Services',
        subtitle: 'Comprehensive Astrological Guidance',
        viewAll: 'View All Services'
      },
      testimonials: {
        title: 'Client Testimonials',
        subtitle: 'What Our Clients Say',
        viewAll: 'View All Testimonials'
      },
      freeConsultation: {
        specialOffer: 'SPECIAL OFFER',
        firstTimeOnly: 'FIRST TIME USERS ONLY',
        title: 'Get Your First Consultation',
        free: 'FREE',
        duration: 'Up to 10 Minutes',
        worth: 'Worth ₹1999',
        expertGuidance: 'Expert Guidance',
        description: 'Experience the power of Vedic astrology with a complimentary consultation. Get personalized insights into your life\'s most important questions.',
        feature1: 'No credit card required',
        feature2: 'Instant booking confirmation',
        feature3: 'Expert astrologer guidance',
        feature4: 'One-time offer for new users',
        ctaButton: 'Claim Your Free Session Now',
        limitedSlots: 'Limited slots available daily. Book now to secure your spot!',
        trustClients: 'Happy Clients',
        trustRating: 'Average Rating',
        trustExperience: 'Years Experience',
        badge100: '100%',
        badgeFree: 'FREE',
        badgeFirstTime: 'First Time',
        badgeConsultation: 'Consultation'
      },
      cta: {
        title: 'Ready to Discover Your Path?',
        subtitle: 'Book a consultation today and unlock the wisdom of Vedic astrology',
        button: 'Schedule Consultation'
      }
    },
    footer: {
      tagline: 'Guiding you through life\'s journey with ancient Vedic wisdom',
      quickLinks: 'Quick Links',
      services: 'Services',
      legal: 'Legal',
      contact: 'Contact Us',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      addressLine1: 'Varanasi, Uttar Pradesh',
      addressLine2: 'India',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      rights: 'All rights reserved.'
    },
    helpBanner: {
      title: 'Need Help with Booking?',
      subtitle: 'Call us directly for easy booking assistance',
      callButton: 'Call Now',
      whatsappButton: 'WhatsApp Us'
    },
    booking: {
      title: 'Book Your Consultation',
      subtitle: 'Fill in your details to schedule a personalized astrology session',
      pageTitle: 'Book a Consultation',
      pageSubtitle: 'Take the first step towards clarity and guidance. Fill out the form below to schedule your session.',
      consultationModeTitle: 'Choose Your Consultation Mode',
      onlineTitle: 'Online Consultation',
      onlineDesc: 'Connect via video call from anywhere. Convenient, comfortable, and just as effective as in-person sessions.',
      inPersonTitle: 'In-Person Consultation',
      inPersonDesc: 'Visit our Ghaziabad location for a personal, face-to-face consultation experience.',
      disclaimerError: 'You must accept the disclaimer to book a consultation.',
      flashSale: 'Flash Sale',
      flashSaleDiscount: 'UP TO 25% OFF',
      flashSaleDescription: 'Grab the deal before it\'s gone! Massive savings on all services',
      offerEndingSoon: 'Ending Soon - Limited Slots Available',
      personalInfo: 'Personal Information',
      name: 'Full Name',
      namePlaceholder: 'Enter your full name',
      email: 'Email Address',
      emailPlaceholder: 'your.email@example.com',
      phone: 'Phone Number',
      phonePlaceholder: '10-digit mobile number',
      birthDetails: 'Birth Details (Optional)',
      birthDetailsNote: 'For accurate birth chart analysis',
      dateOfBirth: 'Date of Birth',
      timeOfBirth: 'Time of Birth',
      placeOfBirth: 'Place of Birth',
      placeOfBirthPlaceholder: 'City, State',
      consultationDetails: 'Consultation Details',
      selectAstrologer: 'Select Astrologer',
      selectService: 'Select Service',
      consultationType: 'Consultation Type',
      online: 'Online (Video Call)',
      inPerson: 'In-Person',
      duration: 'Consultation Duration',
      preferredDate: 'Preferred Date',
      preferredTime: 'Preferred Time',
      selectTime: 'Select a time slot',
      message: 'Message (Optional)',
      messagePlaceholder: 'Any specific questions or concerns...',
      submit: 'Book Consultation',
      submitting: 'Booking...',
      loadingSlots: 'Loading available slots...',
      noSlots: 'No slots available for this date'
    },
    services: {
      birthChart: 'Birth Chart (Kundli) Analysis',
      birthChartDesc: 'Detailed analysis of your birth chart to understand your life path, strengths, and challenges.',
      career: 'Career & Business Guidance',
      careerDesc: 'Strategic insights for career growth, business decisions, and professional success.',
      marriage: 'Marriage & Relationship Compatibility',
      marriageDesc: 'Comprehensive compatibility analysis for harmonious relationships and marriages.',
      health: 'Health & Life Path Insights',
      healthDesc: 'Guidance on health matters and understanding your life\'s purpose and direction.',
      vastu: 'Vastu Consultation',
      vastuDesc: 'Home and office Vastu analysis for positive energy flow and prosperity.',
      palmistry: 'Palmistry',
      palmistryDesc: 'Discover insights about your personality, life path, and future through palm reading.',
      gemstone: 'Gemstone Remedies & Sales',
      gemstoneDesc: 'Personalized gemstone recommendations based on your birth chart. Purchase authentic, energized gemstones directly.',
      childbirth: 'Auspicious Childbirth Timing (Muhurat)',
      childbirthDesc: 'Select the most auspicious and suitable time for childbirth to ensure a prosperous future for your child.',
      namingCeremony: 'Naming Ceremony',
      namingCeremonyDesc: 'Choose the perfect name for your child based on astrological calculations and numerology for a prosperous future.'
    },
    pricing: {
      title: 'Consultation Fees',
      subtitle: 'Transparent pricing for personalized astrological guidance',
      duration1: 'Up to 10 Minutes',
      price1: 'Free',
      worth1: '(Worth ₹1999)',
      desc1: 'Initial consultation for first-time customers',
      badge1: 'First Time Only',
      feature1_1: 'Quick guidance',
      feature1_2: 'Basic questions',
      feature1_3: 'Understanding your concerns',
      duration2: '10+ Minutes',
      price2: 'Varies by Service',
      desc2: 'Professional consultation based on selected service',
      badge2: 'Standard',
      feature2_1: 'Detailed analysis',
      feature2_2: 'Service-specific guidance',
      feature2_3: 'Personalized remedies',
      feature2_4: 'Follow-up support',
      bookNow: 'Book Now',
      specialPricingTitle: 'Special Services Pricing',
      specialPricingDesc: 'Gemstone consultations and purchases are priced separately based on the gemstone type and quality. Childbirth timing (Muhurat) consultations are customized based on detailed analysis requirements.'
    },
    common: {
      readMore: 'Read More',
      bookNow: 'Book Now',
      learnMore: 'Learn More',
      viewAll: 'View All',
      loading: 'Loading...',
      submit: 'Submit',
      cancel: 'Cancel',
      close: 'Close',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort'
    },
    about: {
      title: 'About Acharyaa Indira Pandey',
      subtitle: 'A journey of 20+ years in guiding souls through the ancient wisdom of Vedic astrology',
      yearsExperience: 'Years Experience',
      journeyTitle: 'My Journey Into Astrology',
      journeyPara1: 'My journey into the mystical world of Vedic astrology began over two decades ago, driven by a deep fascination with the cosmic patterns that shape our lives. What started as a personal quest for understanding has blossomed into a profound calling to guide others.',
      journeyPara2: 'Through 20+ years of dedicated study under renowned Vedic scholars and countless hours of chart analysis, I have developed a unique approach that combines traditional wisdom with practical, modern-day applications. My practice is rooted in authenticity, compassion, and a genuine desire to help people find clarity in their life\'s journey.',
      journeyPara3: 'Having guided over 5000+ individuals from diverse backgrounds—including professionals, entrepreneurs, and even well-known personalities—I have witnessed firsthand the transformative power of astrological guidance when delivered with care and precision.',
      bookConsultation: 'Book Your Consultation',
      philosophyTitle: 'My Philosophy & Approach',
      philosophySubtitle: 'Blending ancient wisdom with modern understanding for practical life guidance',
      philosophy1Title: 'Personalized Charts',
      philosophy1Desc: 'Every birth chart is unique. I provide detailed, individualized analysis tailored to your specific planetary positions and life circumstances.',
      philosophy2Title: 'Practical Remedies',
      philosophy2Desc: 'Ancient wisdom meets modern life. I offer remedies that are practical, easy to follow, and seamlessly integrate into your daily routine.',
      philosophy3Title: 'Traditional + Modern',
      philosophy3Desc: 'Combining time-tested Vedic techniques with contemporary understanding to provide relevant and actionable guidance.',
      trustTitle: 'Why Clients Trust Me',
      trustSubtitle: 'Building lasting relationships through accuracy, integrity, and compassion',
      trust1Title: 'Proven Accuracy',
      trust1Desc: 'With a 95%+ client satisfaction rate and 20+ years of experience, my predictions are known for their precision and relevance. Decades of experience have honed my ability to read charts with remarkable accuracy.',
      trust1Stats: '95% Satisfaction',
      trust2Title: 'Trusted by Many',
      trust2Desc: 'From working professionals to business leaders and even celebrities, my client base reflects the trust and credibility I have built over the years.',
      trust2Stats: '5000+ Clients',
      trust3Title: 'Complete Confidentiality',
      trust3Desc: 'Your privacy is my priority. All consultations are conducted with utmost discretion. Many high-profile clients trust me because they know their information is safe.',
      trust3Stats: '100% Private',
      trust4Title: 'Compassionate Guidance',
      trust4Desc: 'Beyond charts and predictions, I genuinely care about helping you navigate life\'s challenges. My approach is empathetic, non-judgmental, and focused on your wellbeing.',
      trust4Stats: '90-100 Weekly Consultations',
      celebrityTitle: 'Trusted by Professionals & Celebrities',
      celebrityDesc: 'My client list includes well-known personalities and celebrities who value discretion and accuracy. Names remain confidential to respect their privacy, but their continued trust speaks volumes about the quality of guidance provided.',
      celebrityQuote: '"Your privacy is sacred. Your trust is my responsibility."',
      ctaTitle: 'Ready to Begin Your Journey?',
      ctaSubtitle: 'Experience personalized astrological guidance that brings clarity, direction, and peace of mind.',
      ctaButton1: 'Book Consultation',
      ctaButton2: 'View Services'
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Have questions? We\'d love to hear from you. Send us a message and we\'ll respond as soon as possible.',
      phoneTitle: 'Phone',
      emailTitle: 'Email',
      locationTitle: 'Location',
      location: 'Ghaziabad, India',
      hoursTitle: 'Working Hours',
      hoursValue: 'Mon-Sat: 9:30 AM - 10 PM',
      formTitle: 'Send Us a Message',
      name: 'Full Name',
      namePlaceholder: 'Enter your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      phone: 'Phone',
      phonePlaceholder: '+91 1234567890',
      subject: 'Subject',
      subjectPlaceholder: 'What is this regarding?',
      message: 'Message',
      messagePlaceholder: 'Your message here...',
      send: 'Send Message',
      sending: 'Sending...',
      required: '*',
      socialTitle: 'Connect With Us',
      socialSubtitle: 'Follow us on social media for daily horoscopes, tips, and updates',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Find answers to common questions about our services'
    },
    team: {
      badge: 'Expert Astrologers Team',
      title: 'Our Team of Astrologers',
      subtitle: 'Three generations of Vedic astrology expertise - combining ancient wisdom with modern understanding',
      experience: 'Years Experience',
      years: 'Years',
      specialization: 'Specializations',
      bookConsultation: 'Book Consultation',
      excellenceTitle: 'Three Generations of Excellence',
      excellence1Title: 'Master Guidance',
      excellence1Desc: '40+ years of ancient wisdom from our founding master astrologer',
      excellence2Title: 'Proven Track Record',
      excellence2Desc: '5000+ satisfied clients with 95% satisfaction rate over 20+ years',
      excellence3Title: 'Modern Approach',
      excellence3Desc: 'Fresh perspectives combined with traditional knowledge for all ages',
      ctaTitle: 'Choose Your Astrologer',
      ctaSubtitle: 'Select the astrologer best suited for your needs and schedule your consultation today',
      ctaButton: 'Book Your Consultation Now',
      astrologer1Name: 'Acharyaa Indira Pandey',
      astrologer1Role: 'Senior Vedic Astrologer',
      astrologer1Bio: 'With over 20 years of experience, Acharyaa Indira Pandey has guided 5000+ clients through accurate predictions and personalized remedies.',
      astrologer1Spec1: 'Birth Chart Analysis',
      astrologer1Spec2: 'Career Guidance',
      astrologer1Spec3: 'Marriage Compatibility',
      astrologer1Spec4: 'Gemstone Remedies',
      astrologer2Name: 'Acharya Ram Nath Tiwari',
      astrologer2Role: 'Master Astrologer & Founder',
      astrologer2Bio: 'A highly respected master astrologer with 40+ years of profound knowledge in Vedic astrology and ancient wisdom.',
      astrologer2Spec1: 'Advanced Birth Chart Analysis',
      astrologer2Spec2: 'Vedic Rituals',
      astrologer2Spec3: 'Childbirth Timing',
      astrologer2Spec4: 'Complex Remedies',
      astrologer3Name: 'Acharyaa Ankita Pandey',
      astrologer3Role: 'Vedic Astrologer & Life Coach',
      astrologer3Bio: 'A dedicated and passionate astrologer specializing in guidance for young adults and modern life challenges with a fresh, relatable approach.',
      astrologer3Spec1: 'Basic Consultations',
      astrologer3Spec2: 'Numerology',
      astrologer3Spec3: 'Vastu Basics',
      astrologer3Spec4: 'Young Adults Guidance'
    },
    testimonials: {
      title: 'Client Testimonials',
      subtitle: 'Real stories from real people who found clarity, direction, and peace through astrological guidance',
      stat1Number: '5000+',
      stat1Label: 'Happy Clients',
      stat2Number: '95%',
      stat2Label: 'Satisfaction Rate',
      stat3Number: '20+',
      stat3Label: 'Years Experience',
      stat4Number: '90-100',
      stat4Label: 'Weekly Sessions',
      moreStoriesTitle: 'More Success Stories',
      videoTitle: 'Video Testimonials Coming Soon',
      videoSubtitle: 'We\'re collecting video testimonials from our satisfied clients. Check back soon to hear directly from those whose lives have been transformed.',
      ctaTitle: 'Become Our Next Success Story',
      ctaSubtitle: 'Join hundreds of satisfied clients who have found clarity and direction through personalized astrological guidance.',
      ctaButton: 'Book Your Consultation Now',
      formTitle: 'Share Your Experience',
      formSubtitle: 'Your feedback helps us serve our clients better and inspires others on their journey',
      formName: 'Your Name',
      formNamePlaceholder: 'Enter your full name',
      formEmail: 'Email Address',
      formEmailPlaceholder: 'your.email@example.com',
      formRating: 'Rating',
      formRatingLabel: 'How would you rate your experience?',
      formService: 'Service Received',
      formServicePlaceholder: 'Select the service you received',
      formLocation: 'Location (Optional)',
      formLocationPlaceholder: 'City, State',
      formTestimonial: 'Your Testimonial',
      formTestimonialPlaceholder: 'Share your experience with us... (minimum 10 characters)',
      formSubmit: 'Submit Testimonial',
      formSubmitting: 'Submitting...',
      formSuccessTitle: 'Thank You!',
      formSuccessMessage: 'Your testimonial has been submitted successfully. It will be published after review.',
      formErrorTitle: 'Submission Failed',
      formErrorMessage: 'Failed to submit testimonial. Please try again.'
    },
    blog: {
      badge: 'Astrological Insights & Wisdom',
      title: 'Astrology Blog',
      subtitle: 'Explore articles on astrology, planetary movements, remedies, and cosmic wisdom',
      searchPlaceholder: 'Search articles...',
      categoryAll: 'All',
      categoryBasics: 'Astrology Basics',
      categoryHoroscope: 'Weekly Horoscope',
      categoryPlanetary: 'Planetary Movements',
      categoryRemedies: 'Remedies',
      featuredArticle: 'Featured Article',
      latestArticles: 'Latest Articles',
      readFullArticle: 'Read Full Article',
      readMore: 'Read More',
      noArticles: 'No articles found matching your search.',
      newsletterTitle: 'Subscribe to Our Newsletter',
      newsletterSubtitle: 'Get weekly horoscopes, astrological insights, and remedies delivered to your inbox',
      newsletterPlaceholder: 'Enter your email',
      newsletterButton: 'Subscribe',
      newsletterButtonLoading: 'Subscribing...',
      newsletterPrivacy: 'We respect your privacy. Unsubscribe at any time.'
    },
    gemstones: {
      badge: 'Authentic Vedic Gemstones',
      title: 'Gemstone Catalog',
      subtitle: 'Authentic, energized gemstones personally selected and blessed by our astrologers',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      weight: 'Weight',
      benefitsLabel: 'Benefits:',
      inquirePrice: 'Inquire for Price',
      consultation: 'Consultation',
      whyChooseTitle: 'Why Choose Our Gemstones?',
      loginRequired: 'Please log in to inquire about gemstone prices',
      inquirySent: 'Inquiry sent successfully! We\'ll contact you shortly.',
      inquiryError: 'Failed to send inquiry. Please try again or contact us directly.',
      sending: 'Sending...',
      inquiryModalTitle: 'Gemstone Inquiry',
      inquiryMessageLabel: 'Your Message',
      inquiryMessagePlaceholder: 'Please tell us about your requirements, preferred weight, budget, or any specific questions...',
      minCharacters: 'Minimum 10 characters',
      characters: 'characters',
      messageMinLength: 'Please enter at least 10 characters in your message',
      cancel: 'Cancel',
      submit: 'Submit Inquiry',
      ruby: {
        name: 'Ruby (Manik)',
        description: 'Powerful gemstone for Sun. Enhances leadership, confidence, and vitality.',
        benefit1: 'Boosts confidence',
        benefit2: 'Enhances leadership',
        benefit3: 'Improves vitality',
        benefit4: 'Brings success'
      },
      pearl: {
        name: 'Pearl (Moti)',
        description: 'Gem for Moon. Brings emotional balance, peace, and mental clarity.',
        benefit1: 'Emotional balance',
        benefit2: 'Mental peace',
        benefit3: 'Enhances intuition',
        benefit4: 'Reduces stress'
      },
      redCoral: {
        name: 'Red Coral (Moonga)',
        description: 'Mars gemstone. Provides courage, energy, and protection.',
        benefit1: 'Increases courage',
        benefit2: 'Boosts energy',
        benefit3: 'Provides protection',
        benefit4: 'Enhances confidence'
      },
      emerald: {
        name: 'Emerald (Panna)',
        description: 'Mercury stone. Enhances communication, intelligence, and business success.',
        benefit1: 'Improves communication',
        benefit2: 'Enhances intelligence',
        benefit3: 'Business success',
        benefit4: 'Memory boost'
      },
      yellowSapphire: {
        name: 'Yellow Sapphire (Pukhraj)',
        description: 'Jupiter gemstone. Brings wisdom, prosperity, and good fortune.',
        benefit1: 'Attracts wealth',
        benefit2: 'Brings wisdom',
        benefit3: 'Good fortune',
        benefit4: 'Career growth'
      },
      blueSapphire: {
        name: 'Blue Sapphire (Neelam)',
        description: 'Saturn stone. Powerful for discipline, focus, and removing obstacles.',
        benefit1: 'Removes obstacles',
        benefit2: 'Enhances discipline',
        benefit3: 'Brings success',
        benefit4: 'Mental clarity'
      },
      feature1Title: '100% Authentic',
      feature1Desc: 'All gemstones are certified and sourced from trusted suppliers',
      feature2Title: 'Energized & Blessed',
      feature2Desc: 'Each gemstone is energized with Vedic mantras by our astrologers',
      feature3Title: 'Personalized Selection',
      feature3Desc: 'Gemstones recommended based on your birth chart analysis',
      ctaTitle: 'Interested in Purchasing a Gemstone?',
      ctaSubtitle: 'Contact us for pricing and availability. Each gemstone is personally selected and energized by our astrologers.',
      ctaDescription: 'Book a consultation to get personalized gemstone recommendations based on your birth chart, along with detailed pricing information.',
      ctaButton1: 'Book Consultation for Gemstone Guidance',
      ctaButton2: 'Contact for Pricing'
    },
    servicesPage: {
      title: 'Our Services',
      subtitle: 'Comprehensive Astrological Guidance for Every Aspect of Life',
      description: 'Explore our range of Vedic astrology services designed to provide clarity, guidance, and solutions for your life\'s journey.',
      flashSaleTitle: 'Flash Sale - Limited Time Only!',
      flashSaleDescription: 'Grab the deal before it\'s gone! Massive savings on all services.',
      flashSaleBadge1: 'Ending Soon',
      flashSaleBadge2: 'Limited Slots',
      flashSaleBadge3: 'Save Big',
      whatsIncluded: 'What\'s Included in Every Consultation',
      whatsIncludedSubtitle: 'Comprehensive analysis and personalized guidance tailored to your needs',
      included1Title: 'Detailed Birth Chart Analysis',
      included1Desc: 'In-depth examination of your complete birth chart with planetary positions and house placements',
      included2Title: 'Personalized Predictions',
      included2Desc: 'Specific forecasts related to your questions and concerns based on current planetary transits',
      included3Title: 'Practical Remedies',
      included3Desc: 'Easy-to-follow Vedic remedies including mantras, gemstones, and lifestyle adjustments',
      included4Title: 'Future Guidance',
      included4Desc: 'Insights into upcoming opportunities and challenges with timing and recommendations',
      included5Title: 'Question & Answer Session',
      included5Desc: 'Dedicated time to address all your specific questions and concerns',
      included6Title: 'Follow-up Support',
      included6Desc: 'Email support for clarifications within 7 days of consultation'
    },
    homeSeoSection: {
      heading: 'Vedic Astrology Services in Ghaziabad and Beyond',
      p1: 'Welcome to <strong>Acharyaa Indira Pandey</strong>, your trusted expert for <strong>Vedic Astrology Services in Ghaziabad</strong> and across India. With years of experience in astrology and spiritual guidance, we offer accurate and personalized insights to help you make informed decisions in your personal, professional, and health matters. Our goal is to empower you with knowledge that aligns your life with cosmic energies and improves your overall well-being.',
      p2: 'At Acharyaa Indira Pandey, we specialize in providing detailed <strong>Marriage Astrology Prediction</strong>, helping individuals and couples understand compatibility, timing, and future prospects in their relationships. Our predictions are based on in-depth analysis of your horoscope, planetary positions, and astrological principles, ensuring clarity and confidence in your life decisions. Whether you are seeking guidance for a new relationship or wish to strengthen your marital bond, our astrology consultations provide actionable insights tailored to your unique life circumstances.',
      p3: 'We also offer comprehensive <strong>Business Astrology Consultation</strong>, designed to support entrepreneurs and professionals in Ghaziabad and beyond. From selecting auspicious dates for launching new ventures to analyzing the potential of business partnerships, our guidance helps you navigate challenges and seize opportunities. With a focus on your goals and planetary influences, our business astrology services ensure you make strategic choices that maximize success and prosperity.',
      p4: 'In addition, our services of <strong>Health Astrology Prediction in Ghaziabad</strong> provide valuable insights into your physical and mental well-being. By examining your astrological chart, we identify potential health challenges and suggest remedies, lifestyle changes, and preventive measures. Our approach combines traditional astrological wisdom with modern understanding, ensuring a balanced and holistic perspective on health and wellness.',
      p5: "At Acharyaa Indira Pandey, we understand that each individual's journey is unique. That's why our consultations are personalized, confidential, and supportive, designed to address your specific concerns. Whether you are in Ghaziabad or anywhere else in India, our expertise is accessible to everyone seeking guidance in love, career, business, and health.",
      p6: 'Our services are complemented by other offerings listed on our website, including astrology predictions for life events, career guidance, and remedies for challenges. By integrating these services, we provide a complete spiritual and astrological solution that empowers you to live your life in harmony with universal energies.',
      p7: 'Contact Acharyaa Indira Pandey today for a consultation and experience the clarity, guidance, and peace that comes from working with a trusted astrology expert in Ghaziabad. Let us help you unlock the potential of your future with precise, insightful, and reliable astrological predictions.',
      ctaButton: 'Book Your Consultation Now'
    },
    servicesFaq: {
      title: 'Frequently Asked Questions',
      q1: 'What services does Happy Kismat offer as an astrologer?',
      a1: 'Happy Kismat offers a range of astrology services, including Vedic astrology, Kundli reading, birth chart analysis, marriage predictions, career guidance, business astrology consultation, and health astrology predictions for clients in Ghaziabad and across India.',
      q2: 'Does Happy Kismat provide astrology consultation outside Ghaziabad?',
      a2: 'Yes, Happy Kismat serves clients in Ghaziabad and across India. Individuals from different locations can access astrology consultation services for Kundli reading, career guidance, marriage predictions, and other astrology needs.',
      q3: 'Where can I get Vedic Astrology services in Ghaziabad?',
      a3: 'Happy Kismat provides Vedic Astrology services in Ghaziabad for individuals seeking personalized horoscope guidance, covering relationships, career, health, finance, and personal development.',
      q4: 'Can I get an online astrology consultation from Happy Kismat?',
      a4: 'Yes, Happy Kismat provides astrology consultation services for clients beyond Ghaziabad, allowing individuals across India to seek personalized Vedic astrology guidance.',
      q5: 'What is Kundli Reading and why is it important?',
      a5: "Kundli Reading involves analyzing a person's birth chart to understand planetary influences affecting different areas of life.",
      q6: 'What is Birth Chart Analysis in astrology?',
      a6: 'Birth Chart Analysis is the study of planetary placements at the time of birth to understand personality traits, life patterns, and potential opportunities.',
      q7: 'Where can I get a marriage astrology prediction in Ghaziabad?',
      a7: 'Happy Kismat provides marriage astrology prediction services in Ghaziabad for individuals seeking guidance about marriage timing, compatibility, and relationship-related concerns.',
      q8: 'How can I book an astrology consultation with Happy Kismat?',
      a8: 'You can contact Happy Kismat to schedule a personalized astrology consultation featuring Vedic astrology and specialized chart readings.'
    },
    birthChartFaq: {
      title: 'Frequently Asked Questions',
      q1: 'What is Birth Chart Analysis in astrology?',
      a1: "Birth Chart Analysis is a Vedic astrology practice that studies the planetary positions at the exact time and place of a person's birth. Happy Kismat utilizes this approach to offer guidance on personality, career, relationships, health, and life opportunities.",
      q2: 'Where can I get a birth chart analysis in Ghaziabad?',
      a2: 'Happy Kismat offers professional services in Ghaziabad to help individuals understand their horoscopes and planetary influences through Vedic astrology.',
      q3: 'How does Birth Chart Analysis work?',
      a3: 'Birth Chart Analysis works by examining the positions of planets, zodiac signs, and houses at the time of birth, interpreted using Vedic methods for personalized insights.',
      q4: 'What information is required for Birth Chart Analysis?',
      a4: 'For accurate Birth Chart Analysis, astrologers generally require your date of birth, exact time of birth, and place of birth.',
      q5: 'Can I get an online Birth Chart Analysis from Happy Kismat?',
      a5: 'Yes, Happy Kismat provides remote consultations across India, allowing clients to receive personalized guidance using their birth details.',
      q6: 'Why should I choose Happy Kismat for Birth Chart Analysis?',
      a6: 'Happy Kismat offers guidance related to career, marriage, health, and personal growth using Vedic astrology methods, with a personalized and compassionate approach for each client.',
      q7: 'Does Happy Kismat provide Birth Chart Analysis outside Ghaziabad?',
      a7: 'Yes, Happy Kismat provides Birth Chart Analysis services for clients in Ghaziabad and across India.',
      q8: 'How can I book a Birth Chart Analysis with Happy Kismat?',
      a8: 'Contact Happy Kismat to schedule a consultation by sharing your birth details for personalized Vedic astrology guidance.'
    },
    manageBookings: {
      title: 'My Bookings',
      subtitle: 'Manage your consultation bookings',
      filterTitle: 'Filter Bookings',
      upcoming: 'Upcoming',
      cancelled: 'Cancelled',
      last3months: 'Last 3 Months',
      last6months: 'Last 6 Months',
      allBookings: 'All Bookings',
      showing: 'Showing',
      booking: 'booking',
      bookings: 'bookings',
      noBookingsTitle: 'No bookings yet',
      noBookingsDesc: 'You haven\'t made any bookings yet.',
      bookConsultation: 'Book a Consultation',
      noMatchTitle: 'No bookings found',
      noMatchDesc: 'No bookings match the selected filter.',
      viewAllBookings: 'View All Bookings',
      astrologer: 'Astrologer',
      date: 'Date',
      time: 'Time',
      amount: 'Amount',
      free: 'Free',
      duration: 'Duration',
      minutes: 'minutes',
      type: 'Type',
      bookingId: 'Booking ID',
      refundStatus: 'Refund Status',
      status: 'Status',
      refundAmount: 'Amount',
      refundCompleted: 'Refund completed. Amount will be credited within 5-7 business days.',
      refundPending: 'Refund is being processed. You\'ll receive an email once completed.',
      toBeScheduled: 'To be scheduled',
      cancelled: 'This booking was cancelled',
      completed: 'Completed',
      confirmed: 'Confirmed',
      completePayment: 'Complete Payment',
      processingPayment: 'Processing Payment...',
      paymentExpired: 'Payment window expired',
      cancelBooking: 'Cancel Booking',
      cancelling: 'Cancelling...',
      bookingExpired: 'Booking expired',
      page: 'Page',
      of: 'of',
      previous: 'Previous',
      next: 'Next',
      cancelDialogTitle: 'Cancel Booking',
      cancelDialogDesc: 'Are you sure you want to cancel this booking?',
      refundEligible: 'You are eligible for',
      refund: 'refund',
      noRefund: 'No refund will be issued',
      reason: 'Reason',
      confirmCancel: 'Yes, Cancel Booking',
      keepBooking: 'Keep Booking',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      statusCancelled: 'Cancelled',
      statusCompleted: 'Completed',
      paymentPending: 'Payment Pending',
      paymentCompleted: 'Payment Completed',
      paymentFailed: 'Payment Failed'
    }
  },
  hi: {
    header: {
      home: 'होम',
      about: 'हमारे बारे में',
      team: 'हमारी टीम',
      services: 'सेवाएं',
      gemstones: 'रत्न',
      testimonials: 'प्रशंसापत्र',
      blog: 'ब्लॉग',
      contact: 'संपर्क करें',
      bookConsultation: 'परामर्श बुक करें',
      vedicAstrologer: 'वैदिक ज्योतिषी'
    },
    home: {
      hero: {
        title: 'अपनी किस्मत जानें',
        subtitle: 'प्राचीन वैदिक ज्ञान के माध्यम से',
        description: 'आचार्या इंदिरा पांडे के साथ प्रामाणिक वैदिक ज्योतिष मार्गदर्शन का अनुभव करें। जन्म कुंडली विश्लेषण, करियर मार्गदर्शन और व्यक्तिगत उपायों में 20 से अधिक वर्षों की विशेषज्ञता।',
        cta: 'अपना परामर्श बुक करें',
        learnMore: 'और जानें',
        astrologerName: 'आचार्या इंदिरा पांडे'
      },
      stats: {
        experience: 'वर्षों का अनुभव',
        clients: 'संतुष्ट ग्राहक',
        satisfaction: 'संतुष्टि दर',
        consultations: 'परामर्श/सप्ताह'
      },
      whyChoose: {
        title: 'आचार्या इंदिरा पांडे को क्यों चुनें?',
        subtitle: 'व्यक्तिगत, सटीक और दयालु ज्योतिषीय मार्गदर्शन के अंतर का अनुभव करें',
        card1Title: 'विशेषज्ञ मार्गदर्शन',
        card1Desc: 'सिद्ध सटीकता के साथ वैदिक ज्योतिष में 20+ वर्षों का समर्पित अभ्यास',
        card2Title: 'कई लोगों द्वारा विश्वसनीय',
        card2Desc: 'पेशेवरों और सेलिब्रिटीज सहित 5000+ संतुष्ट ग्राहक',
        card3Title: 'व्यक्तिगत दृष्टिकोण',
        card3Desc: 'प्रत्येक परामर्श आपकी अनूठी जन्म कुंडली और आवश्यकताओं के अनुरूप है',
        card4Title: 'पूर्ण गोपनीयता',
        card4Desc: 'आपकी गोपनीयता सर्वोपरि है। सभी परामर्श पूरी तरह से गोपनीय रहते हैं'
      },
      services: {
        title: 'हमारी सेवाएं',
        subtitle: 'व्यापक ज्योतिषीय मार्गदर्शन',
        viewAll: 'सभी सेवाएं देखें'
      },
      testimonials: {
        title: 'ग्राहक प्रशंसापत्र',
        subtitle: 'हमारे ग्राहक क्या कहते हैं',
        viewAll: 'सभी प्रशंसापत्र देखें'
      },
      freeConsultation: {
        specialOffer: 'विशेष ऑफर',
        firstTimeOnly: 'केवल पहली बार उपयोगकर्ताओं के लिए',
        title: 'अपना पहला परामर्श प्राप्त करें',
        free: 'मुफ्त',
        duration: '10 मिनट तक',
        worth: '₹1999 मूल्य का',
        expertGuidance: 'विशेषज्ञ मार्गदर्शन',
        description: 'मुफ्त परामर्श के साथ वैदिक ज्योतिष की शक्ति का अनुभव करें। अपने जीवन के सबसे महत्वपूर्ण सवालों के लिए व्यक्तिगत अंतर्दृष्टि प्राप्त करें।',
        feature1: 'क्रेडिट कार्ड की आवश्यकता नहीं',
        feature2: 'तत्काल बुकिंग पुष्टि',
        feature3: 'विशेषज्ञ ज्योतिषी मार्गदर्शन',
        feature4: 'नए उपयोगकर्ताओं के लिए एक बार का ऑफर',
        ctaButton: 'अपना मुफ्त सत्र अभी क्लेम करें',
        limitedSlots: 'सीमित स्लॉट प्रतिदिन उपलब्ध। अपनी जगह सुरक्षित करने के लिए अभी बुक करें!',
        trustClients: 'संतुष्ट ग्राहक',
        trustRating: 'औसत रेटिंग',
        trustExperience: 'वर्षों का अनुभव',
        badge100: '100%',
        badgeFree: 'मुफ्त',
        badgeFirstTime: 'पहली बार',
        badgeConsultation: 'परामर्श'
      },
      cta: {
        title: 'अपना रास्ता खोजने के लिए तैयार हैं?',
        subtitle: 'आज ही परामर्श बुक करें और वैदिक ज्योतिष का ज्ञान प्राप्त करें',
        button: 'परामर्श निर्धारित करें'
      }
    },
    footer: {
      tagline: 'प्राचीन वैदिक ज्ञान के साथ जीवन की यात्रा में आपका मार्गदर्शन',
      quickLinks: 'त्वरित लिंक',
      services: 'सेवाएं',
      legal: 'कानूनी',
      contact: 'संपर्क करें',
      phone: 'फोन',
      email: 'ईमेल',
      address: 'पता',
      addressLine1: 'वाराणसी, उत्तर प्रदेश',
      addressLine2: 'भारत',
      privacyPolicy: 'गोपनीयता नीति',
      termsOfService: 'सेवा की शर्तें',
      rights: 'सर्वाधिकार सुरक्षित।'
    },
    helpBanner: {
      title: 'बुकिंग में मदद चाहिए?',
      subtitle: 'आसान बुकिंग सहायता के लिए हमें सीधे कॉल करें',
      callButton: 'अभी कॉल करें',
      whatsappButton: 'व्हाट्सएप करें'
    },
    booking: {
      title: 'अपना परामर्श बुक करें',
      subtitle: 'व्यक्तिगत ज्योतिष सत्र निर्धारित करने के लिए अपना विवरण भरें',
      pageTitle: 'परामर्श बुक करें',
      pageSubtitle: 'स्पष्टता और मार्गदर्शन की दिशा में पहला कदम उठाएं। अपना सत्र निर्धारित करने के लिए नीचे दिया गया फॉर्म भरें।',
      consultationModeTitle: 'अपना परामर्श मोड चुनें',
      onlineTitle: 'ऑनलाइन परामर्श',
      onlineDesc: 'कहीं से भी वीडियो कॉल के माध्यम से जुड़ें। सुविधाजनक, आरामदायक और व्यक्तिगत सत्रों जितना ही प्रभावी।',
      inPersonTitle: 'व्यक्तिगत परामर्श',
      inPersonDesc: 'व्यक्तिगत, आमने-सामने परामर्श अनुभव के लिए हमारे गाजियाबाद स्थान पर जाएं।',
      disclaimerError: 'परामर्श बुक करने के लिए आपको अस्वीकरण स्वीकार करना होगा।',
      flashSale: 'फ्लैश सेल',
      flashSaleDiscount: '25% तक की छूट',
      flashSaleDescription: 'यह सौदा खत्म होने से पहले पकड़ लें! सभी सेवाओं पर भारी बचत',
      offerEndingSoon: 'जल्द समाप्त हो रहा है - सीमित स्लॉट उपलब्ध',
      personalInfo: 'व्यक्तिगत जानकारी',
      name: 'पूरा नाम',
      namePlaceholder: 'अपना पूरा नाम दर्ज करें',
      email: 'ईमेल पता',
      emailPlaceholder: 'your.email@example.com',
      phone: 'फोन नंबर',
      phonePlaceholder: '10 अंकों का मोबाइल नंबर',
      birthDetails: 'जन्म विवरण (वैकल्पिक)',
      birthDetailsNote: 'सटीक जन्म कुंडली विश्लेषण के लिए',
      dateOfBirth: 'जन्म तिथि',
      timeOfBirth: 'जन्म समय',
      placeOfBirth: 'जन्म स्थान',
      placeOfBirthPlaceholder: 'शहर, राज्य',
      consultationDetails: 'परामर्श विवरण',
      selectAstrologer: 'ज्योतिषी चुनें',
      selectService: 'सेवा चुनें',
      consultationType: 'परामर्श प्रकार',
      online: 'ऑनलाइन (वीडियो कॉल)',
      inPerson: 'व्यक्तिगत रूप से',
      duration: 'परामर्श अवधि',
      preferredDate: 'पसंदीदा तिथि',
      preferredTime: 'पसंदीदा समय',
      selectTime: 'समय स्लॉट चुनें',
      message: 'संदेश (वैकल्पिक)',
      messagePlaceholder: 'कोई विशिष्ट प्रश्न या चिंताएं...',
      submit: 'परामर्श बुक करें',
      submitting: 'बुकिंग हो रही है...',
      loadingSlots: 'उपलब्ध स्लॉट लोड हो रहे हैं...',
      noSlots: 'इस तिथि के लिए कोई स्लॉट उपलब्ध नहीं है'
    },
    services: {
      birthChart: 'जन्म कुंडली (कुंडली) विश्लेषण',
      birthChartDesc: 'अपने जीवन पथ, शक्तियों और चुनौतियों को समझने के लिए आपकी जन्म कुंडली का विस्तृत विश्लेषण।',
      career: 'करियर और व्यवसाय मार्गदर्शन',
      careerDesc: 'करियर विकास, व्यावसायिक निर्णयों और पेशेवर सफलता के लिए रणनीतिक अंतर्दृष्टि।',
      marriage: 'विवाह और रिश्ते की अनुकूलता',
      marriageDesc: 'सामंजस्यपूर्ण संबंधों और विवाह के लिए व्यापक अनुकूलता विश्लेषण।',
      health: 'स्वास्थ्य और जीवन पथ अंतर्दृष्टि',
      healthDesc: 'स्वास्थ्य मामलों पर मार्गदर्शन और आपके जीवन के उद्देश्य और दिशा को समझना।',
      vastu: 'वास्तु परामर्श',
      vastuDesc: 'सकारात्मक ऊर्जा प्रवाह और समृद्धि के लिए घर और कार्यालय वास्तु विश्लेषण।',
      palmistry: 'हस्तरेखा विज्ञान',
      palmistryDesc: 'हस्तरेखा पढ़ने के माध्यम से अपने व्यक्तित्व, जीवन पथ और भविष्य के बारे में जानकारी प्राप्त करें।',
      gemstone: 'रत्न उपचार और बिक्री',
      gemstoneDesc: 'आपकी जन्म कुंडली के आधार पर व्यक्तिगत रत्न सिफारिशें। प्रामाणिक, ऊर्जावान रत्न सीधे खरीदें।',
      childbirth: 'शुभ प्रसव समय (मुहूर्त)',
      childbirthDesc: 'अपने बच्चे के समृद्ध भविष्य को सुनिश्चित करने के लिए प्रसव के लिए सबसे शुभ और उपयुक्त समय का चयन करें।',
      namingCeremony: 'नामकरण संस्कार',
      namingCeremonyDesc: 'समृद्ध भविष्य के लिए ज्योतिषीय गणना और अंकशास्त्र के आधार पर अपने बच्चे के लिए सही नाम चुनें।'
    },
    pricing: {
      title: 'परामर्श शुल्क',
      subtitle: 'व्यक्तिगत ज्योतिषीय मार्गदर्शन के लिए पारदर्शी मूल्य निर्धारण',
      duration1: '10 मिनट तक',
      price1: 'निःशुल्क',
      worth1: '(₹1999 मूल्य का)',
      desc1: 'पहली बार ग्राहकों के लिए प्रारंभिक परामर्श',
      badge1: 'केवल पहली बार',
      feature1_1: 'त्वरित मार्गदर्शन',
      feature1_2: 'बुनियादी प्रश्न',
      feature1_3: 'आपकी चिंताओं को समझना',
      duration2: '10+ मिनट',
      price2: 'सेवा के अनुसार भिन्न',
      desc2: 'चयनित सेवा के आधार पर पेशेवर परामर्श',
      badge2: 'मानक',
      feature2_1: 'विस्तृत विश्लेषण',
      feature2_2: 'सेवा-विशिष्ट मार्गदर्शन',
      feature2_3: 'व्यक्तिगत उपाय',
      feature2_4: 'अनुवर्ती सहायता',
      bookNow: 'अभी बुक करें',
      specialPricingTitle: 'विशेष सेवाओं का मूल्य निर्धारण',
      specialPricingDesc: 'रत्न परामर्श और खरीद रत्न के प्रकार और गुणवत्ता के आधार पर अलग से मूल्य निर्धारित की जाती है। प्रसव समय (मुहूर्त) परामर्श विस्तृत विश्लेषण आवश्यकताओं के आधार पर अनुकूलित किए जाते हैं।'
    },
    common: {
      readMore: 'और पढ़ें',
      bookNow: 'अभी बुक करें',
      learnMore: 'और जानें',
      viewAll: 'सभी देखें',
      loading: 'लोड हो रहा है...',
      submit: 'जमा करें',
      cancel: 'रद्द करें',
      close: 'बंद करें',
      save: 'सहेजें',
      edit: 'संपादित करें',
      delete: 'हटाएं',
      search: 'खोजें',
      filter: 'फ़िल्टर',
      sort: 'क्रमबद्ध करें'
    },
    about: {
      title: 'आचार्या इंदिरा पांडे के बारे में',
      subtitle: 'प्राचीन वैदिक ज्ञान के माध्यम से आत्माओं का मार्गदर्शन करने में 20+ वर्षों की यात्रा',
      yearsExperience: 'वर्षों का अनुभव',
      journeyTitle: 'ज्योतिष में मेरी यात्रा',
      journeyPara1: 'वैदिक ज्योतिष की रहस्यमय दुनिया में मेरी यात्रा दो दशक पहले शुरू हुई, जो हमारे जीवन को आकार देने वाले ब्रह्मांडीय पैटर्न के प्रति गहरे आकर्षण से प्रेरित थी। जो समझ की व्यक्तिगत खोज के रूप में शुरू हुआ, वह दूसरों का मार्गदर्शन करने के गहन आह्वान में विकसित हो गया है।',
      journeyPara2: 'प्रसिद्ध वैदिक विद्वानों के तहत 20+ वर्षों के समर्पित अध्ययन और कुंडली विश्लेषण के अनगिनत घंटों के माध्यम से, मैंने एक अनूठा दृष्टिकोण विकसित किया है जो पारंपरिक ज्ञान को व्यावहारिक, आधुनिक अनुप्रयोगों के साथ जोड़ता है। मेरा अभ्यास प्रामाणिकता, करुणा और लोगों को उनकी जीवन यात्रा में स्पष्टता खोजने में मदद करने की वास्तविक इच्छा में निहित है।',
      journeyPara3: 'पेशेवरों, उद्यमियों और यहां तक कि प्रसिद्ध व्यक्तित्वों सहित विविध पृष्ठभूमि के 5000+ से अधिक व्यक्तियों का मार्गदर्शन करते हुए, मैंने देखभाल और सटीकता के साथ दिए जाने पर ज्योतिषीय मार्गदर्शन की परिवर्तनकारी शक्ति को प्रत्यक्ष रूप से देखा है।',
      bookConsultation: 'अपना परामर्श बुक करें',
      philosophyTitle: 'मेरा दर्शन और दृष्टिकोण',
      philosophySubtitle: 'व्यावहारिक जीवन मार्गदर्शन के लिए प्राचीन ज्ञान को आधुनिक समझ के साथ मिलाना',
      philosophy1Title: 'व्यक्तिगत कुंडली',
      philosophy1Desc: 'प्रत्येक जन्म कुंडली अद्वितीय है। मैं आपकी विशिष्ट ग्रह स्थितियों और जीवन परिस्थितियों के अनुरूप विस्तृत, व्यक्तिगत विश्लेषण प्रदान करती हूं।',
      philosophy2Title: 'व्यावहारिक उपाय',
      philosophy2Desc: 'प्राचीन ज्ञान आधुनिक जीवन से मिलता है। मैं ऐसे उपाय प्रदान करती हूं जो व्यावहारिक, पालन करने में आसान हैं और आपकी दैनिक दिनचर्या में सहजता से एकीकृत होते हैं।',
      philosophy3Title: 'पारंपरिक + आधुनिक',
      philosophy3Desc: 'प्रासंगिक और कार्रवाई योग्य मार्गदर्शन प्रदान करने के लिए समय-परीक्षणित वैदिक तकनीकों को समकालीन समझ के साथ जोड़ना।',
      trustTitle: 'ग्राहक मुझ पर क्यों भरोसा करते हैं',
      trustSubtitle: 'सटीकता, ईमानदारी और करुणा के माध्यम से स्थायी संबंध बनाना',
      trust1Title: 'सिद्ध सटीकता',
      trust1Desc: '95%+ ग्राहक संतुष्टि दर और 20+ वर्षों के अनुभव के साथ, मेरी भविष्यवाणियां उनकी सटीकता और प्रासंगिकता के लिए जानी जाती हैं। दशकों के अनुभव ने उल्लेखनीय सटीकता के साथ कुंडली पढ़ने की मेरी क्षमता को निखारा है।',
      trust1Stats: '95% संतुष्टि',
      trust2Title: 'कई लोगों द्वारा विश्वसनीय',
      trust2Desc: 'कामकाजी पेशेवरों से लेकर व्यापारिक नेताओं और यहां तक कि सेलिब्रिटीज तक, मेरा ग्राहक आधार उस विश्वास और विश्वसनीयता को दर्शाता है जो मैंने वर्षों में बनाई है।',
      trust2Stats: '5000+ ग्राहक',
      trust3Title: 'पूर्ण गोपनीयता',
      trust3Desc: 'आपकी गोपनीयता मेरी प्राथमिकता है। सभी परामर्श अत्यधिक विवेक के साथ आयोजित किए जाते हैं। कई हाई-प्रोफाइल ग्राहक मुझ पर भरोसा करते हैं क्योंकि वे जानते हैं कि उनकी जानकारी सुरक्षित है।',
      trust3Stats: '100% निजी',
      trust4Title: 'करुणामय मार्गदर्शन',
      trust4Desc: 'कुंडली और भविष्यवाणियों से परे, मैं वास्तव में आपको जीवन की चुनौतियों से निपटने में मदद करने की परवाह करती हूं। मेरा दृष्टिकोण सहानुभूतिपूर्ण, गैर-निर्णयात्मक और आपकी भलाई पर केंद्रित है।',
      trust4Stats: '90-100 साप्ताहिक परामर्श',
      celebrityTitle: 'पेशेवरों और सेलिब्रिटीज द्वारा विश्वसनीय',
      celebrityDesc: 'मेरी ग्राहक सूची में प्रसिद्ध व्यक्तित्व और सेलिब्रिटीज शामिल हैं जो विवेक और सटीकता को महत्व देते हैं। उनकी गोपनीयता का सम्मान करने के लिए नाम गोपनीय रखे जाते हैं, लेकिन उनका निरंतर विश्वास प्रदान किए गए मार्गदर्शन की गुणवत्ता के बारे में बहुत कुछ कहता है।',
      celebrityQuote: '"आपकी गोपनीयता पवित्र है। आपका विश्वास मेरी जिम्मेदारी है।"',
      ctaTitle: 'अपनी यात्रा शुरू करने के लिए तैयार हैं?',
      ctaSubtitle: 'व्यक्तिगत ज्योतिषीय मार्गदर्शन का अनुभव करें जो स्पष्टता, दिशा और मन की शांति लाता है।',
      ctaButton1: 'परामर्श बुक करें',
      ctaButton2: 'सेवाएं देखें'
    },
    contact: {
      title: 'संपर्क करें',
      subtitle: 'कोई प्रश्न हैं? हम आपसे सुनना पसंद करेंगे। हमें एक संदेश भेजें और हम जल्द से जल्द जवाब देंगे।',
      phoneTitle: 'फोन',
      emailTitle: 'ईमेल',
      locationTitle: 'स्थान',
      location: 'गाजियाबाद, भारत',
      hoursTitle: 'कार्य समय',
      hoursValue: 'सोमवार-शनिवार: सुबह 9:30 बजे - रात 10 बजे',
      formTitle: 'हमें एक संदेश भेजें',
      name: 'पूरा नाम',
      namePlaceholder: 'अपना नाम दर्ज करें',
      email: 'ईमेल',
      emailPlaceholder: 'your@email.com',
      phone: 'फोन',
      phonePlaceholder: '+91 1234567890',
      subject: 'विषय',
      subjectPlaceholder: 'यह किस बारे में है?',
      message: 'संदेश',
      messagePlaceholder: 'आपका संदेश यहां...',
      send: 'संदेश भेजें',
      sending: 'भेजा जा रहा है...',
      required: '*',
      socialTitle: 'हमसे जुड़ें',
      socialSubtitle: 'दैनिक राशिफल, सुझाव और अपडेट के लिए हमें सोशल मीडिया पर फॉलो करें',
      faqTitle: 'अक्सर पूछे जाने वाले प्रश्न',
      faqSubtitle: 'हमारी सेवाओं के बारे में सामान्य प्रश्नों के उत्तर खोजें'
    },
    team: {
      badge: 'विशेषज्ञ ज्योतिषी टीम',
      title: 'हमारे ज्योतिषियों की टीम',
      subtitle: 'वैदिक ज्योतिष विशेषज्ञता की तीन पीढ़ियां - प्राचीन ज्ञान को आधुनिक समझ के साथ जोड़ना',
      experience: 'वर्षों का अनुभव',
      years: 'वर्ष',
      specialization: 'विशेषज्ञता',
      bookConsultation: 'परामर्श बुक करें',
      excellenceTitle: 'उत्कृष्टता की तीन पीढ़ियां',
      excellence1Title: 'मास्टर मार्गदर्शन',
      excellence1Desc: 'हमारे संस्थापक मास्टर ज्योतिषी से 40+ वर्षों का प्राचीन ज्ञान',
      excellence2Title: 'सिद्ध ट्रैक रिकॉर्ड',
      excellence2Desc: '20+ वर्षों में 95% संतुष्टि दर के साथ 5000+ संतुष्ट ग्राहक',
      excellence3Title: 'आधुनिक दृष्टिकोण',
      excellence3Desc: 'सभी उम्र के लिए पारंपरिक ज्ञान के साथ नए दृष्टिकोण',
      ctaTitle: 'अपना ज्योतिषी चुनें',
      ctaSubtitle: 'अपनी आवश्यकताओं के लिए सबसे उपयुक्त ज्योतिषी का चयन करें और आज ही अपना परामर्श निर्धारित करें',
      ctaButton: 'अभी अपना परामर्श बुक करें',
      astrologer1Name: 'आचार्या इंदिरा पांडे',
      astrologer1Role: 'वरिष्ठ वैदिक ज्योतिषी',
      astrologer1Bio: '20 से अधिक वर्षों के अनुभव के साथ, आचार्या इंदिरा पांडे ने सटीक भविष्यवाणियों और व्यक्तिगत उपायों के माध्यम से 5000+ ग्राहकों का मार्गदर्शन किया है।',
      astrologer1Spec1: 'जन्म कुंडली विश्लेषण',
      astrologer1Spec2: 'करियर मार्गदर्शन',
      astrologer1Spec3: 'विवाह अनुकूलता',
      astrologer1Spec4: 'रत्न उपचार',
      astrologer2Name: 'आचार्य राम नाथ तिवारी',
      astrologer2Role: 'मास्टर ज्योतिषी और संस्थापक',
      astrologer2Bio: 'वैदिक ज्योतिष और प्राचीन ज्ञान में 40+ वर्षों के गहन ज्ञान के साथ एक अत्यधिक सम्मानित मास्टर ज्योतिषी।',
      astrologer2Spec1: 'उन्नत जन्म कुंडली विश्लेषण',
      astrologer2Spec2: 'वैदिक अनुष्ठान',
      astrologer2Spec3: 'बच्चे के जन्म का समय',
      astrologer2Spec4: 'जटिल उपचार',
      astrologer3Name: 'आचार्या अंकिता पांडे',
      astrologer3Role: 'वैदिक ज्योतिषी और जीवन कोच',
      astrologer3Bio: 'युवा वयस्कों और आधुनिक जीवन की चुनौतियों के लिए मार्गदर्शन में विशेषज्ञता रखने वाली एक समर्पित और भावुक ज्योतिषी, जो एक ताज़ा और सहज दृष्टिकोण के साथ।',
      astrologer3Spec1: 'बुनियादी परामर्श',
      astrologer3Spec2: 'अंकशास्त्र',
      astrologer3Spec3: 'वास्तु मूल बातें',
      astrologer3Spec4: 'युवा वयस्कों का मार्गदर्शन'
    },
    testimonials: {
      title: 'ग्राहक प्रशंसापत्र',
      subtitle: 'वास्तविक लोगों की वास्तविक कहानियां जिन्होंने ज्योतिषीय मार्गदर्शन के माध्यम से स्पष्टता, दिशा और शांति पाई',
      stat1Number: '5000+',
      stat1Label: 'संतुष्ट ग्राहक',
      stat2Number: '95%',
      stat2Label: 'संतुष्टि दर',
      stat3Number: '20+',
      stat3Label: 'वर्षों का अनुभव',
      stat4Number: '90-100',
      stat4Label: 'साप्ताहिक सत्र',
      moreStoriesTitle: 'अधिक सफलता की कहानियां',
      videoTitle: 'वीडियो प्रशंसापत्र जल्द आ रहे हैं',
      videoSubtitle: 'हम अपने संतुष्ट ग्राहकों से वीडियो प्रशंसापत्र एकत्र कर रहे हैं। उन लोगों से सीधे सुनने के लिए जल्द ही वापस देखें जिनके जीवन बदल गए हैं।',
      ctaTitle: 'हमारी अगली सफलता की कहानी बनें',
      ctaSubtitle: 'सैकड़ों संतुष्ट ग्राहकों में शामिल हों जिन्होंने व्यक्तिगत ज्योतिषीय मार्गदर्शन के माध्यम से स्पष्टता और दिशा पाई है।',
      ctaButton: 'अभी अपना परामर्श बुक करें',
      formTitle: 'अपना अनुभव साझा करें',
      formSubtitle: 'आपकी प्रतिक्रिया हमें अपने ग्राहकों की बेहतर सेवा करने में मदद करती है और दूसरों को उनकी यात्रा में प्रेरित करती है',
      formName: 'आपका नाम',
      formNamePlaceholder: 'अपना पूरा नाम दर्ज करें',
      formEmail: 'ईमेल पता',
      formEmailPlaceholder: 'your.email@example.com',
      formRating: 'रेटिंग',
      formRatingLabel: 'आप अपने अनुभव को कैसे रेट करेंगे?',
      formService: 'प्राप्त सेवा',
      formServicePlaceholder: 'आपने जो सेवा प्राप्त की उसे चुनें',
      formLocation: 'स्थान (वैकल्पिक)',
      formLocationPlaceholder: 'शहर, राज्य',
      formTestimonial: 'आपका प्रशंसापत्र',
      formTestimonialPlaceholder: 'हमारे साथ अपना अनुभव साझा करें... (न्यूनतम 10 अक्षर)',
      formSubmit: 'प्रशंसापत्र सबमिट करें',
      formSubmitting: 'सबमिट हो रहा है...',
      formSuccessTitle: 'धन्यवाद!',
      formSuccessMessage: 'आपका प्रशंसापत्र सफलतापूर्वक सबमिट किया गया है। समीक्षा के बाद इसे प्रकाशित किया जाएगा।',
      formErrorTitle: 'सबमिशन विफल',
      formErrorMessage: 'प्रशंसापत्र सबमिट करने में विफल। कृपया पुनः प्रयास करें।'
    },
    blog: {
      badge: 'ज्योतिषीय अंतर्दृष्टि और ज्ञान',
      title: 'ज्योतिष ब्लॉग',
      subtitle: 'ज्योतिष, ग्रहों की गति, उपाय और ब्रह्मांडीय ज्ञान पर लेख देखें',
      searchPlaceholder: 'लेख खोजें...',
      categoryAll: 'सभी',
      categoryBasics: 'ज्योतिष मूल बातें',
      categoryHoroscope: 'साप्ताहिक राशिफल',
      categoryPlanetary: 'ग्रहों की गति',
      categoryRemedies: 'उपाय',
      featuredArticle: 'विशेष लेख',
      latestArticles: 'नवीनतम लेख',
      readFullArticle: 'पूरा लेख पढ़ें',
      readMore: 'और पढ़ें',
      noArticles: 'आपकी खोज से मेल खाने वाला कोई लेख नहीं मिला।',
      newsletterTitle: 'हमारे न्यूज़लेटर की सदस्यता लें',
      newsletterSubtitle: 'साप्ताहिक राशिफल, ज्योतिषीय अंतर्दृष्टि और उपाय अपने इनबॉक्स में प्राप्त करें',
      newsletterPlaceholder: 'अपना ईमेल दर्ज करें',
      newsletterButton: 'सदस्यता लें',
      newsletterButtonLoading: 'सदस्यता ली जा रही है...',
      newsletterPrivacy: 'हम आपकी गोपनीयता का सम्मान करते हैं। किसी भी समय सदस्यता समाप्त करें।'
    },
    gemstones: {
      badge: 'प्रामाणिक वैदिक रत्न',
      title: 'रत्न कैटलॉग',
      subtitle: 'हमारे ज्योतिषियों द्वारा व्यक्तिगत रूप से चयनित और आशीर्वादित प्रामाणिक, ऊर्जावान रत्न',
      inStock: 'स्टॉक में',
      outOfStock: 'स्टॉक में नहीं',
      weight: 'वजन',
      benefitsLabel: 'लाभ:',
      inquirePrice: 'मूल्य के लिए पूछताछ करें',
      consultation: 'परामर्श',
      whyChooseTitle: 'हमारे रत्न क्यों चुनें?',
      loginRequired: 'रत्न की कीमत के बारे में पूछताछ करने के लिए कृपया लॉग इन करें',
      inquirySent: 'पूछताछ सफलतापूर्वक भेजी गई! हम जल्द ही आपसे संपर्क करेंगे।',
      inquiryError: 'पूछताछ भेजने में विफल। कृपया पुनः प्रयास करें या सीधे हमसे संपर्क करें।',
      sending: 'भेजा जा रहा है...',
      inquiryModalTitle: 'रत्न पूछताछ',
      inquiryMessageLabel: 'आपका संदेश',
      inquiryMessagePlaceholder: 'कृपया हमें अपनी आवश्यकताओं, पसंदीदा वजन, बजट या किसी विशिष्ट प्रश्न के बारे में बताएं...',
      minCharacters: 'न्यूनतम 10 अक्षर',
      characters: 'अक्षर',
      messageMinLength: 'कृपया अपने संदेश में कम से कम 10 अक्षर दर्ज करें',
      cancel: 'रद्द करें',
      submit: 'पूछताछ सबमिट करें',
      ruby: {
        name: 'माणिक (Manik)',
        description: 'सूर्य के लिए शक्तिशाली रत्न। नेतृत्व, आत्मविश्वास और जीवन शक्ति को बढ़ाता है।',
        benefit1: 'आत्मविश्वास बढ़ाता है',
        benefit2: 'नेतृत्व क्षमता बढ़ाता है',
        benefit3: 'जीवन शक्ति में सुधार',
        benefit4: 'सफलता लाता है'
      },
      pearl: {
        name: 'मोती (Moti)',
        description: 'चंद्रमा का रत्न। भावनात्मक संतुलन, शांति और मानसिक स्पष्टता लाता है।',
        benefit1: 'भावनात्मक संतुलन',
        benefit2: 'मानसिक शांति',
        benefit3: 'अंतर्ज्ञान बढ़ाता है',
        benefit4: 'तनाव कम करता है'
      },
      redCoral: {
        name: 'मूंगा (Moonga)',
        description: 'मंगल का रत्न। साहस, ऊर्जा और सुरक्षा प्रदान करता है।',
        benefit1: 'साहस बढ़ाता है',
        benefit2: 'ऊर्जा को बढ़ावा देता है',
        benefit3: 'सुरक्षा प्रदान करता है',
        benefit4: 'आत्मविश्वास बढ़ाता है'
      },
      emerald: {
        name: 'पन्ना (Panna)',
        description: 'बुध का रत्न। संचार, बुद्धि और व्यावसायिक सफलता को बढ़ाता है।',
        benefit1: 'संचार में सुधार',
        benefit2: 'बुद्धि बढ़ाता है',
        benefit3: 'व्यावसायिक सफलता',
        benefit4: 'स्मृति को बढ़ावा'
      },
      yellowSapphire: {
        name: 'पुखराज (Pukhraj)',
        description: 'बृहस्पति का रत्न। ज्ञान, समृद्धि और सौभाग्य लाता है।',
        benefit1: 'धन आकर्षित करता है',
        benefit2: 'ज्ञान लाता है',
        benefit3: 'सौभाग्य',
        benefit4: 'करियर में वृद्धि'
      },
      blueSapphire: {
        name: 'नीलम (Neelam)',
        description: 'शनि का रत्न। अनुशासन, फोकस और बाधाओं को दूर करने के लिए शक्तिशाली।',
        benefit1: 'बाधाओं को दूर करता है',
        benefit2: 'अनुशासन बढ़ाता है',
        benefit3: 'सफलता लाता है',
        benefit4: 'मानसिक स्पष्टता'
      },
      feature1Title: '100% प्रामाणिक',
      feature1Desc: 'सभी रत्न प्रमाणित हैं और विश्वसनीय आपूर्तिकर्ताओं से प्राप्त किए गए हैं',
      feature2Title: 'ऊर्जावान और आशीर्वादित',
      feature2Desc: 'प्रत्येक रत्न को हमारे ज्योतिषियों द्वारा वैदिक मंत्रों से ऊर्जावान किया जाता है',
      feature3Title: 'व्यक्तिगत चयन',
      feature3Desc: 'आपकी जन्म कुंडली विश्लेषण के आधार पर अनुशंसित रत्न',
      ctaTitle: 'रत्न खरीदने में रुचि है?',
      ctaSubtitle: 'मूल्य और उपलब्धता के लिए हमसे संपर्क करें। प्रत्येक रत्न को हमारे ज्योतिषियों द्वारा व्यक्तिगत रूप से चुना और ऊर्जावान किया जाता है।',
      ctaDescription: 'अपनी जन्म कुंडली के आधार पर व्यक्तिगत रत्न सिफारिशें प्राप्त करने के लिए परामर्श बुक करें, विस्तृत मूल्य जानकारी के साथ।',
      ctaButton1: 'रत्न मार्गदर्शन के लिए परामर्श बुक करें',
      ctaButton2: 'मूल्य के लिए संपर्क करें'
    },
    servicesPage: {
      title: 'हमारी सेवाएं',
      subtitle: 'जीवन के हर पहलू के लिए व्यापक ज्योतिषीय मार्गदर्शन',
      description: 'अपनी जीवन यात्रा के लिए स्पष्टता, मार्गदर्शन और समाधान प्रदान करने के लिए डिज़ाइन की गई हमारी वैदिक ज्योतिष सेवाओं की श्रृंखला का अन्वेषण करें।',
      flashSaleTitle: 'फ्लैश सेल - सीमित समय के लिए!',
      flashSaleDescription: 'यह सौदा खत्म होने से पहले पकड़ लें! सभी सेवाओं पर भारी बचत।',
      flashSaleBadge1: 'जल्द समाप्त',
      flashSaleBadge2: 'सीमित स्लॉट',
      flashSaleBadge3: 'बड़ी बचत',
      whatsIncluded: 'प्रत्येक परामर्श में क्या शामिल है',
      whatsIncludedSubtitle: 'आपकी आवश्यकताओं के अनुरूप व्यापक विश्लेषण और व्यक्तिगत मार्गदर्शन',
      included1Title: 'विस्तृत जन्म कुंडली विश्लेषण',
      included1Desc: 'ग्रहों की स्थिति और भाव स्थानों के साथ आपकी पूर्ण जन्म कुंडली की गहन जांच',
      included2Title: 'व्यक्तिगत भविष्यवाणियां',
      included2Desc: 'वर्तमान ग्रह संक्रमणों के आधार पर आपके प्रश्नों और चिंताओं से संबंधित विशिष्ट पूर्वानुमान',
      included3Title: 'व्यावहारिक उपाय',
      included3Desc: 'मंत्र, रत्न और जीवनशैली समायोजन सहित आसान वैदिक उपाय',
      included4Title: 'भविष्य का मार्गदर्शन',
      included4Desc: 'समय और सिफारिशों के साथ आगामी अवसरों और चुनौतियों की अंतर्दृष्टि',
      included5Title: 'प्रश्नोत्तर सत्र',
      included5Desc: 'आपके सभी विशिष्ट प्रश्नों और चिंताओं को संबोधित करने के लिए समर्पित समय',
      included6Title: 'अनुवर्ती सहायता',
      included6Desc: 'परामर्श के 7 दिनों के भीतर स्पष्टीकरण के लिए ईमेल सहायता'
    },
    homeSeoSection: {
      heading: 'गाजियाबाद और उससे परे वैदिक ज्योतिष सेवाएं',
      p1: '<strong>आचार्या इंदिरा पांडे</strong> में आपका स्वागत है, जो <strong>गाजियाबाद में वैदिक ज्योतिष सेवाओं</strong> और पूरे भारत के लिए आपकी विश्वसनीय विशेषज्ञ हैं। ज्योतिष और आध्यात्मिक मार्गदर्शन में वर्षों के अनुभव के साथ, हम आपको अपने व्यक्तिगत, पेशेवर और स्वास्थ्य संबंधी मामलों में सूचित निर्णय लेने में मदद करने के लिए सटीक और व्यक्तिगत अंतर्दृष्टि प्रदान करते हैं। हमारा लक्ष्य आपको ऐसे ज्ञान से सशक्त बनाना है जो आपके जीवन को ब्रह्मांडीय ऊर्जाओं के साथ संरेखित करे और आपके समग्र कल्याण में सुधार करे।',
      p2: 'आचार्या इंदिरा पांडे में, हम विस्तृत <strong>विवाह ज्योतिष भविष्यवाणी</strong> प्रदान करने में विशेषज्ञ हैं, जो व्यक्तियों और जोड़ों को उनके रिश्तों में अनुकूलता, समय और भविष्य की संभावनाओं को समझने में मदद करती है। हमारी भविष्यवाणियां आपकी जन्म कुंडली, ग्रहीय स्थितियों और ज्योतिषीय सिद्धांतों के गहन विश्लेषण पर आधारित हैं, जो आपके जीवन निर्णयों में स्पष्टता और आत्मविश्वास सुनिश्चित करती हैं।',
      p3: 'हम व्यापक <strong>व्यापार ज्योतिष परामर्श</strong> भी प्रदान करते हैं, जो गाजियाबाद और उससे परे उद्यमियों और पेशेवरों का समर्थन करने के लिए डिज़ाइन किया गया है। नए उद्यम शुरू करने के लिए शुभ तिथियों के चयन से लेकर व्यावसायिक साझेदारी की संभावनाओं का विश्लेषण करने तक, हमारा मार्गदर्शन आपको चुनौतियों से निपटने और अवसरों को जब्त करने में मदद करता है।',
      p4: 'इसके अतिरिक्त, <strong>गाजियाबाद में स्वास्थ्य ज्योतिष भविष्यवाणी</strong> की हमारी सेवाएं आपके शारीरिक और मानसिक स्वास्थ्य में मूल्यवान अंतर्दृष्टि प्रदान करती हैं। आपकी ज्योतिषीय कुंडली की जांच करके, हम संभावित स्वास्थ्य चुनौतियों की पहचान करते हैं और उपाय, जीवनशैली में बदलाव और निवारक उपाय सुझाते हैं।',
      p5: 'आचार्या इंदिरा पांडे में, हम समझते हैं कि प्रत्येक व्यक्ति की यात्रा अद्वितीय है। इसीलिए हमारे परामर्श व्यक्तिगत, गोपनीय और सहायक हैं, जो आपकी विशिष्ट चिंताओं को संबोधित करने के लिए डिज़ाइन किए गए हैं। चाहे आप गाजियाबाद में हों या भारत में कहीं भी, हमारी विशेषज्ञता प्रेम, करियर, व्यापार और स्वास्थ्य में मार्गदर्शन चाहने वाले सभी के लिए सुलभ है।',
      p6: 'हमारी सेवाएं हमारी वेबसाइट पर सूचीबद्ध अन्य प्रस्तावों द्वारा पूरक हैं, जिनमें जीवन की घटनाओं के लिए ज्योतिष भविष्यवाणियां, करियर मार्गदर्शन और चुनौतियों के लिए उपाय शामिल हैं। इन सेवाओं को एकीकृत करके, हम एक संपूर्ण आध्यात्मिक और ज्योतिषीय समाधान प्रदान करते हैं जो आपको सार्वभौमिक ऊर्जाओं के साथ सामंजस्य में जीने के लिए सशक्त बनाता है।',
      p7: 'आज ही आचार्या इंदिरा पांडे से परामर्श के लिए संपर्क करें और गाजियाबाद में एक विश्वसनीय ज्योतिष विशेषज्ञ के साथ काम करने से मिलने वाली स्पष्टता, मार्गदर्शन और शांति का अनुभव करें। हमें आपको सटीक, अंतर्दृष्टिपूर्ण और विश्वसनीय ज्योतिषीय भविष्यवाणियों के साथ आपके भविष्य की संभावनाओं को उजागर करने में मदद करने दें।',
      ctaButton: 'अभी अपना परामर्श बुक करें'
    },
    servicesFaq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      q1: 'हैप्पी किस्मत एक ज्योतिषी के रूप में क्या सेवाएं प्रदान करता है?',
      a1: 'हैप्पी किस्मत वैदिक ज्योतिष, कुंडली पठन, जन्म कुंडली विश्लेषण, विवाह भविष्यवाणी, करियर मार्गदर्शन, व्यापार ज्योतिष परामर्श और स्वास्थ्य ज्योतिष भविष्यवाणी सहित ज्योतिष सेवाओं की एक श्रृंखला प्रदान करता है, जो गाजियाबाद और पूरे भारत के ग्राहकों के लिए है।',
      q2: 'क्या हैप्पी किस्मत गाजियाबाद के बाहर ज्योतिष परामर्श प्रदान करता है?',
      a2: 'हां, हैप्पी किस्मत गाजियाबाद और पूरे भारत में ग्राहकों की सेवा करता है। विभिन्न स्थानों से व्यक्ति कुंडली पठन, करियर मार्गदर्शन, विवाह भविष्यवाणी और अन्य ज्योतिष आवश्यकताओं के लिए परामर्श सेवाओं का उपयोग कर सकते हैं।',
      q3: 'मुझे गाजियाबाद में वैदिक ज्योतिष सेवाएं कहां मिल सकती हैं?',
      a3: 'हैप्पी किस्मत गाजियाबाद में व्यक्तिगत राशिफल मार्गदर्शन चाहने वाले व्यक्तियों के लिए वैदिक ज्योतिष सेवाएं प्रदान करता है, जिसमें रिश्ते, करियर, स्वास्थ्य, वित्त और व्यक्तिगत विकास शामिल हैं।',
      q4: 'क्या मुझे हैप्पी किस्मत से ऑनलाइन ज्योतिष परामर्श मिल सकता है?',
      a4: 'हां, हैप्पी किस्मत गाजियाबाद से परे ग्राहकों के लिए ज्योतिष परामर्श सेवाएं प्रदान करता है, जिससे पूरे भारत के व्यक्ति व्यक्तिगत वैदिक ज्योतिष मार्गदर्शन प्राप्त कर सकते हैं।',
      q5: 'कुंडली पठन क्या है और यह क्यों महत्वपूर्ण है?',
      a5: 'कुंडली पठन में जीवन के विभिन्न क्षेत्रों को प्रभावित करने वाले ग्रहीय प्रभावों को समझने के लिए किसी व्यक्ति की जन्म कुंडली का विश्लेषण करना शामिल है।',
      q6: 'ज्योतिष में जन्म कुंडली विश्लेषण क्या है?',
      a6: 'जन्म कुंडली विश्लेषण व्यक्तित्व लक्षणों, जीवन पैटर्न और संभावित अवसरों को समझने के लिए जन्म के समय ग्रहों की स्थिति का अध्ययन है।',
      q7: 'मुझे गाजियाबाद में विवाह ज्योतिष भविष्यवाणी कहां मिल सकती है?',
      a7: 'हैप्पी किस्मत गाजियाबाद में विवाह समय, अनुकूलता और रिश्ते से संबंधित चिंताओं के बारे में मार्गदर्शन चाहने वाले व्यक्तियों के लिए विवाह ज्योतिष भविष्यवाणी सेवाएं प्रदान करता है।',
      q8: 'मैं हैप्पी किस्मत के साथ ज्योतिष परामर्श कैसे बुक कर सकता/सकती हूं?',
      a8: 'आप वैदिक ज्योतिष और विशेष कुंडली पठन सहित एक व्यक्तिगत ज्योतिष परामर्श निर्धारित करने के लिए हैप्पी किस्मत से संपर्क कर सकते हैं।'
    },
    birthChartFaq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      q1: 'ज्योतिष में जन्म कुंडली विश्लेषण क्या है?',
      a1: 'जन्म कुंडली विश्लेषण एक वैदिक ज्योतिष पद्धति है जो किसी व्यक्ति के जन्म के ठीक समय और स्थान पर ग्रहों की स्थितियों का अध्ययन करती है। हैप्पी किस्मत व्यक्तित्व, करियर, रिश्ते, स्वास्थ्य और जीवन के अवसरों पर मार्गदर्शन प्रदान करने के लिए इस दृष्टिकोण का उपयोग करता है।',
      q2: 'मुझे गाजियाबाद में जन्म कुंडली विश्लेषण कहां मिल सकता है?',
      a2: 'हैप्पी किस्मत गाजियाबाद में पेशेवर सेवाएं प्रदान करता है जो व्यक्तियों को वैदिक ज्योतिष के माध्यम से उनकी कुंडली और ग्रहीय प्रभावों को समझने में मदद करती हैं।',
      q3: 'जन्म कुंडली विश्लेषण कैसे काम करता है?',
      a3: 'जन्म कुंडली विश्लेषण जन्म के समय ग्रहों, राशियों और भावों की स्थितियों की जांच करके काम करता है, जिसे व्यक्तिगत अंतर्दृष्टि के लिए वैदिक विधियों का उपयोग करके व्याख्यायित किया जाता है।',
      q4: 'जन्म कुंडली विश्लेषण के लिए क्या जानकारी आवश्यक है?',
      a4: 'सटीक जन्म कुंडली विश्लेषण के लिए, ज्योतिषियों को आमतौर पर आपकी जन्म तिथि, जन्म का सटीक समय और जन्म स्थान की आवश्यकता होती है।',
      q5: 'क्या मुझे हैप्पी किस्मत से ऑनलाइन जन्म कुंडली विश्लेषण मिल सकता है?',
      a5: 'हां, हैप्पी किस्मत पूरे भारत में दूरस्थ परामर्श प्रदान करता है, जिससे ग्राहकों को उनके जन्म विवरण का उपयोग करके व्यक्तिगत मार्गदर्शन प्राप्त करने की अनुमति मिलती है।',
      q6: 'जन्म कुंडली विश्लेषण के लिए मुझे हैप्पी किस्मत को क्यों चुनना चाहिए?',
      a6: 'हैप्पी किस्मत प्रत्येक ग्राहक के लिए व्यक्तिगत और दयालु दृष्टिकोण के साथ वैदिक ज्योतिष विधियों का उपयोग करके करियर, विवाह, स्वास्थ्य और व्यक्तिगत विकास से संबंधित मार्गदर्शन प्रदान करता है।',
      q7: 'क्या हैप्पी किस्मत गाजियाबाद के बाहर जन्म कुंडली विश्लेषण प्रदान करता है?',
      a7: 'हां, हैप्पी किस्मत गाजियाबाद और पूरे भारत में ग्राहकों के लिए जन्म कुंडली विश्लेषण सेवाएं प्रदान करता है।',
      q8: 'मैं हैप्पी किस्मत के साथ जन्म कुंडली विश्लेषण कैसे बुक कर सकता/सकती हूं?',
      a8: 'व्यक्तिगत वैदिक ज्योतिष मार्गदर्शन के लिए अपना जन्म विवरण साझा करके परामर्श निर्धारित करने के लिए हैप्पी किस्मत से संपर्क करें।'
    },
    manageBookings: {
      title: 'मेरी बुकिंग',
      subtitle: 'अपनी परामर्श बुकिंग प्रबंधित करें',
      filterTitle: 'बुकिंग फ़िल्टर करें',
      upcoming: 'आगामी',
      cancelled: 'रद्द',
      last3months: 'पिछले 3 महीने',
      last6months: 'पिछले 6 महीने',
      allBookings: 'सभी बुकिंग',
      showing: 'दिखा रहे हैं',
      booking: 'बुकिंग',
      bookings: 'बुकिंग',
      noBookingsTitle: 'अभी तक कोई बुकिंग नहीं',
      noBookingsDesc: 'आपने अभी तक कोई बुकिंग नहीं की है।',
      bookConsultation: 'परामर्श बुक करें',
      noMatchTitle: 'कोई बुकिंग नहीं मिली',
      noMatchDesc: 'चयनित फ़िल्टर से कोई बुकिंग मेल नहीं खाती।',
      viewAllBookings: 'सभी बुकिंग देखें',
      astrologer: 'ज्योतिषी',
      date: 'तारीख',
      time: 'समय',
      amount: 'राशि',
      free: 'निःशुल्क',
      duration: 'अवधि',
      minutes: 'मिनट',
      type: 'प्रकार',
      bookingId: 'बुकिंग आईडी',
      refundStatus: 'धनवापसी स्थिति',
      status: 'स्थिति',
      refundAmount: 'राशि',
      refundCompleted: 'धनवापसी पूर्ण। राशि 5-7 व्यावसायिक दिनों में जमा की जाएगी।',
      refundPending: 'धनवापसी प्रक्रिया में है। पूर्ण होने पर आपको ईमेल प्राप्त होगा।',
      toBeScheduled: 'निर्धारित किया जाना है',
      cancelled: 'यह बुकिंग रद्द कर दी गई थी',
      completed: 'पूर्ण',
      confirmed: 'पुष्टि',
      completePayment: 'भुगतान पूर्ण करें',
      processingPayment: 'भुगतान प्रक्रिया में...',
      paymentExpired: 'भुगतान समय समाप्त',
      cancelBooking: 'बुकिंग रद्द करें',
      cancelling: 'रद्द कर रहे हैं...',
      bookingExpired: 'बुकिंग समाप्त',
      page: 'पृष्ठ',
      of: 'का',
      previous: 'पिछला',
      next: 'अगला',
      cancelDialogTitle: 'बुकिंग रद्द करें',
      cancelDialogDesc: 'क्या आप वाकई इस बुकिंग को रद्द करना चाहते हैं?',
      refundEligible: 'आप पात्र हैं',
      refund: 'धनवापसी',
      noRefund: 'कोई धनवापसी जारी नहीं की जाएगी',
      reason: 'कारण',
      confirmCancel: 'हां, बुकिंग रद्द करें',
      keepBooking: 'बुकिंग रखें',
      statusPending: 'लंबित',
      statusConfirmed: 'पुष्टि',
      statusCancelled: 'रद्द',
      statusCompleted: 'पूर्ण',
      paymentPending: 'भुगतान लंबित',
      paymentCompleted: 'भुगतान पूर्ण',
      paymentFailed: 'भुगतान विफल'
    }
  }
};

